// Import: Middleware Action & Custom Types
import {
    CLEAN_LEAD_BY_CAMPAING,
    CLEAN_LEAD_BY_CAMPAING_ERROR,
} from "_models/redux/types";

// Action function
export const cleanLeadsByCampaingAction = (params) => async (dispatch) => {
    // Endpoint: Try & Catch
    try {
        dispatch({
            payload: undefined,
            type: CLEAN_LEAD_BY_CAMPAING,
        });
    } catch (e) {
        dispatch({
            payload: undefined,
            type: CLEAN_LEAD_BY_CAMPAING_ERROR,
        });
    }
};
